import { useMemo } from 'react';

import { useStatusContext } from 'pages/Status/context';

import {
  LINE_2_STANDARD,
  LINE_2_SUPPLY,
  SUBTITLE_ARRAY,
  SUBTITLE_ARRAY_DELIVERY,
} from './constants';

interface PaidByBankAcceptedHook {
  subtitleArray: string[];
  companyName: string;
  line2: string;
  isExampleJob: boolean;
  isLoading: boolean;
}

export default function usePaidByBankAccepted(): PaidByBankAcceptedHook {
  const { job, jobCompanyInfo, isLoading, isDeliveryOnly } = useStatusContext();

  const isExampleJob = job?.flow_type === 'example';

  const companyName = useMemo(() => {
    if (!jobCompanyInfo || isLoading) return 'Your tradesperson';
    return jobCompanyInfo?.company_name || 'Your tradesperson';
  }, [jobCompanyInfo, isLoading]);

  const subtitleArray = useMemo(() => {
    const base = isDeliveryOnly ? SUBTITLE_ARRAY_DELIVERY : SUBTITLE_ARRAY;
    return base.map((segment) => segment.replace('$partner', companyName));
  }, [companyName, isDeliveryOnly]);

  const line2 = useMemo(
    () => (isDeliveryOnly ? LINE_2_SUPPLY : LINE_2_STANDARD),
    [isDeliveryOnly],
  );

  return {
    subtitleArray,
    companyName,
    line2,
    isExampleJob,
    isLoading,
  };
}
